import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { formatCurrencyValue } from 'utils/format';

import { FeesStepTestIds } from '../../FeesStep.testIds';
import ToleranceChip from '../ToleranceChip';

import {
  amountStyles,
  cardStyles,
  chipColumnStyles,
  rowsStyles,
  rowStyles,
  rowTextStyles,
  sectionsLabelStyles,
  titleStyles,
} from './FeeToleranceLegend.styles';

const FeeToleranceLegend = ({ buckets }) => {
  if (!buckets.length) {
    return null;
  }

  return (
    <Box data-testid={FeesStepTestIds.TOLERANCE_LEGEND} sx={cardStyles}>
      <Typography sx={titleStyles} variant="bold12">
        Tolerance Buckets
      </Typography>
      <Box sx={rowsStyles}>
        {buckets.map(({ category, chip, description, sections, amount }) => (
          <Box key={category} sx={rowStyles}>
            <Box sx={chipColumnStyles}>
              <ToleranceChip config={chip} />
            </Box>
            <Box sx={rowTextStyles}>
              <Typography variant="regular14">{description}</Typography>
              <Typography sx={sectionsLabelStyles} variant="regular12">
                {`Section${sections.length > 1 ? 's' : ''} ${sections.join(', ')}`}
              </Typography>
            </Box>
            <Typography sx={amountStyles} variant="bold14">
              {formatCurrencyValue(amount)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

FeeToleranceLegend.propTypes = {
  buckets: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      sections: PropTypes.arrayOf(PropTypes.string).isRequired,
      chip: PropTypes.object,
      description: PropTypes.string,
      amount: PropTypes.number,
    }),
  ).isRequired,
};

export default memo(FeeToleranceLegend);
